
import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    setDoc,
    Timestamp,
} from "firebase/firestore";

import { db } from "../apis/auth";



export async function getAllTickets(zone = 0, ward = 0, deviceType = -1, states = [0, 1, 2, 3]) {

    var queryObj = query(
        collection(db(), 'tickets'));
    if (zone !== 0) {
        queryObj = query(
            queryObj,
            where("zn", "==", zone));

        if (ward !== 0) {
            queryObj = query(
                queryObj,
                where("wd", "==", ward));
        }
    }
    if (deviceType !== -1) {
        queryObj = query(
            queryObj,
            where("dt", "==", deviceType));
    }
    queryObj = query(
        queryObj,
        where("st", "in", states));

    queryObj = query(
        queryObj,
        orderBy("ct", "desc"));

    var data = [];
    // debugger;
    await getDocs(queryObj).then((querySnapshot) => {

        querySnapshot.forEach((doc) => {
            console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
            data.push(doc.data());
        });

    }).catch((error) => {
        console.log(`====> Error fetch : ${error}`);
        return Promise.reject(error);
    });
    // debugger;
    return Promise.resolve(data);
}
export async function getAllTicketsByDate(zone = 0, ward = 0, deviceType = -1, states = [0, 1, 2, 3], createdDate, resolvedDate, durationFilter, falg) {
    var queryObj = query(collection(db(), 'tickets'));

    if (createdDate && createdDate.start && createdDate.end) {
        if (createdDate.start instanceof Date && createdDate.end instanceof Date) {
            createdDate.start.setHours(0, 0, 0, 0);
            createdDate.end.setHours(23, 59, 59, 0);
            queryObj = query(queryObj, where("ct", ">=", createdDate.start));
            queryObj = query(queryObj, where("ct", "<=", createdDate.end));

        }
    }
    if (durationFilter && durationFilter.start && durationFilter.end) {
        if (durationFilter.start instanceof Date && durationFilter.end instanceof Date) {
            durationFilter.start.setHours(0, 0, 0, 0);
            durationFilter.end.setHours(23, 59, 59, 0);
            if (!falg) {
                queryObj = query(queryObj, where("ct", "<=", durationFilter.start));
            } else {
                queryObj = query(queryObj, where("ct", ">=", durationFilter.start));
                queryObj = query(queryObj, where("ct", "<=", durationFilter.end));
            }
        }
    }

    if (resolvedDate && resolvedDate.start && resolvedDate.end) {
        if (resolvedDate.start instanceof Date && resolvedDate.end instanceof Date) {
            resolvedDate.start.setHours(0, 0, 0, 0);
            resolvedDate.end.setHours(23, 59, 59, 0);
            queryObj = query(queryObj, where("mt", ">=", resolvedDate.start));
            queryObj = query(queryObj, where("mt", "<=", resolvedDate.end));
        }
    }

    if (zone !== 0) {
        queryObj = query(queryObj, where("zn", "==", zone));

        if (ward !== 0) {
            queryObj = query(queryObj, where("wd", "==", ward));
        }
    }

    if (deviceType !== -1) {
        queryObj = query(queryObj, where("dt", "==", deviceType));
    }

    queryObj = query(queryObj, where("st", "in", states));

    var data = [];

    await getDocs(queryObj).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
            data.push(doc.data());
        });
    }).catch((error) => {
        console.log(`====> Error fetch : ${error}`);
        return Promise.reject(error);
    });

    return Promise.resolve(data);
}
export async function createTicket(data) {
    const collectionRef = collection(db(), "tickets");
    await setDoc(doc(collectionRef, data.id), data).catch((e) => {
        return Promise.error(e);
    });
    return Promise.resolve();

}

export async function updateTicket(data) {
  try {
    const collectionRef = collection(db(), "tickets");

    const q = query(collectionRef, where("id", "==", data.id));

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("Document not found");
      return;
    }

    const document = querySnapshot.docs[0];

    await updateDoc(doc(collectionRef, document.id), data);

    console.log("Updated successfully");
  } catch (e) {
    console.log("====> Error update :", e);
  }
}

export async function getTicketCount() {
 
     const startOfJanuary = new Date(new Date().getFullYear(), 0, 1);
    const startTimestamp = Timestamp.fromDate(startOfJanuary);

    const endOfJanuaryNextYear = new Date(new Date().getFullYear() + 1, 0, 1);
    const endTimestamp = Timestamp.fromDate(endOfJanuaryNextYear);

    let data = { assignedCount: 0, closedCount: 0 };
      let queryRef = query(
        collection(db(), 'tickets'),
        where("st", "in", [1, 4]),  
        where("ct", ">=", startTimestamp),
        where("ct", "<", endTimestamp),
        orderBy("ct", "desc")
    );


    try {
        const querySnapshot = await getDocs(queryRef);
        querySnapshot.forEach((doc) => {
            const ticket = doc.data();
            // console.log("Ticket data:", JSON.stringify(ticket));

            if (ticket.st === 1) {
                data.assignedCount += 1;
            } else if (ticket.st === 4) {
                data.closedCount += 1;
            }
        });

     } catch (error) {
        console.error(`Error fetching tickets: ${error}`);
        return Promise.reject(error);
    }

    console.log('Final count:', data);
    return data;
}